import React, { PureComponent } from 'react'
import { Select, Icon } from "@driftt/tide-core-legacy"

class TargetedAccountsAction extends PureComponent {

  constructor(props) {
    super(props)

    this.state = {
      selectedValue: "default-settings"
    }
  }

  renderSelectOption = ({ label }) => {
    const iconName = 'user-circle'

    return (
      <div className="participant-type-dropdown-option">
        <Icon height={14} width={14} name={iconName}/>
        <span >{label}</span>
      </div>
    )
  }

  render() {
    return (
      <div className="participant-actions">
        <header>
          <h1>Review Settings</h1>
          <p>Please note that default settings for targeted accounts are populated below.</p>
        </header>
        <div className="participant-action-selector">
          <div className="participant-action-selector-description">How do you want to add participants?</div>
          <Select
            multi={false}
            options={[{label: "Add single person", value: "default-settings"}]}
            optionRenderer={this.renderSelectOption}
            valueRenderer={this.renderSelectOption}
            autoFocus={true}
            clearable={false}
            value={this.state.selectedValue}
            disabled
          />
          <p>Automatically add one user or account owner to each new conversation. If you choose a team, one member from the team will automatically be added to each conversation. </p>
        </div>
        <div className="participant-action-selector">
          <div className="participant-action-selector-description">Who do you want to add?</div>
          <Select
              multi={false}
              options={[{label: "Drift account owner", value: "default-settings"}]}
              autoFocus={true}
              clearable={false}
              value={this.state.selectedValue}
              disabled
            />
        </div>
      </div>
    )
  }

}

export default TargetedAccountsAction



// WEBPACK FOOTER //
// ./src/scripts/components/settings/Rules/components/ActionEditor/TargetedAccountsAction.js